export default "__VITE_ASSET__8c903678__"